export enum TRACK_CHANGE_STATUS_LABELS {
    OPEN = 'Open',
    RESOLVED = 'Resolved',
}

export enum TRACK_CHANGE_STATUS_VALUES {
    OPEN = 'OPEN',
    RESOLVED = 'RESOLVED',
}

export enum TRACK_CHANGE_STATUS {
    PENDING = 'PENDING',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    OPTIONGROUP = 'OPTIONGROUP',
    MODIFIED = 'MODIFIED',
}

// Map track change status to labels (direct mapping)
export const TRACK_CHANGE_STATUS_MAP: Record<string, TRACK_CHANGE_STATUS[]> = {
    OPEN: [
        TRACK_CHANGE_STATUS.PENDING,
        TRACK_CHANGE_STATUS.OPTIONGROUP,
        TRACK_CHANGE_STATUS.MODIFIED,
    ],
    RESOLVED: [TRACK_CHANGE_STATUS.APPROVED, TRACK_CHANGE_STATUS.REJECTED],
}

export const defaultSuggestionCardFilter = TRACK_CHANGE_STATUS_VALUES.OPEN

export const CardInteractionKeys = {
    Enter: 'Enter',
    Space: 'Space',
} as const
